// eslint-disable-next-line no-restricted-imports
import { Settings } from "luxon";
import type { AWSDateTime } from "../schema/AWSDateTime.js";
import { appDateTimeZone } from "../schema/appDateTimeZone.js";

Settings.throwOnInvalid = true;
Settings.defaultZone = appDateTimeZone;

declare module "luxon" {
	interface TSSettings {
		throwOnInvalid: true;
	}

	interface DateTime {
		toISO(options?: { includeOffset?: true; suppressMilliseconds?: boolean }): AWSDateTime;
	}
}

// eslint-disable-next-line no-restricted-imports
export * from "luxon";
